var defaultTheme={modalTheme:{content:{}}};export{defaultTheme};
//# sourceMappingURL=defaults.js.map
